export namespace PlanningMessage {
    export const PLANNING_TOAST_MESSAGE = "planning-toast-message";
}
